import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import AppraisalCertificate from './AppraisalCertificate';
import { pdf } from '@react-pdf/renderer';
import './styles.css';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Modal from 'react-modal';
import { API_BASE_URL } from "../config/config";


const EditAppraisalRequest = () => {


    const { id } = useParams(); // Get the object ID from the URL
    const [formData, setFormData] = useState(null);
    const location = useLocation();
    const queryParams = new URLSearchParams(window.location.search);
    const contactIdFromQuery = queryParams.get('contactId');
    const [contactId, setContactId] = useState(location.state?.contactId || contactIdFromQuery || '');
    const [loading, setLoading] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);

    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [previewImageSrc, setPreviewImageSrc] = useState('/previewButtonHeader.svg');
    const [saveButtonImageSrc, setSaveButtonImageSrc] = useState('/saveButtonHeader.svg');
    const [isLoading, setIsLoading] = useState(false);
    const [onClickHandler, setOnClickHandler] = useState(() => () => { });
    const [savedFormsImageSrc, setSavedFormsImageSrc] = useState('/savedFormsButtomHeader.svg');
    const [notes, setNotes] = useState([]);  // Initialize as an empty array
    const [color, setColor] = useState(''); // State to store the color input
    const [files, setFiles] = useState([]); // State to store fetched files
    const [selectedImage, setSelectedImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [isUploading, setIsUploading] = useState(false); // Add this state
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pdfBlobUrl, setPdfBlobUrl] = useState('');


    const handleFetchObject = async () => {
        if (!contactId) return;

        try {
            setLoading(true);
            const response = await fetch(`${API_BASE_URL}/api/crm/get-contact?contactId=${contactId}`);
            if (!response.ok) throw new Error('Failed to fetch contact data');

            const data = await response.json();
            if (!data.ContactId) {
                setError('No contact found with the given ID.');
                setFormData(null);
                return;
            }

            setFormData({
                ...data,
                color: data.color || '', // Provide a default value if not present
                notes: notes || '',
            });

        } catch (error) {
            console.error('Error fetching contact:', error);
            setError('Error fetching contact data.');
        } finally {
            setLoading(false);
        }
    };


    const handleFileChange = async (e) => {
        const files = Array.from(e.target.files);
        console.log('Files selected from local disk:', files);

        if (!files.length) return;

        const maxImages = 6;
        const newImages = [];

        for (const file of files) {
            if (selectedImages.length + newImages.length >= maxImages) {
                alert(`You can only upload up to ${maxImages} images.`);
                break;
            }

            const formData = new FormData();
            formData.append('image', file);

            try {
                const response = await fetch(`${API_BASE_URL}/api/upload-certificate-image`, {
                    method: 'POST',
                    body: formData,
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    console.error('Error uploading image:', errorData.error);
                    continue; // Skip this file and proceed to the next
                }

                const data = await response.json();
                console.log('Uploaded image URL:', data.imageUrl);
                newImages.push(data.imageUrl);
            } catch (error) {
                console.error('Error uploading image:', error.message);
            }
        }

        // Update selectedImages state
        setSelectedImages((prevImages) => {
            const combinedImages = [...prevImages, ...newImages];
            console.log('Updated selectedImages:', combinedImages);
            return combinedImages.slice(0, maxImages);
        });
    };



    const handleColorChange = (event) => {
        const newColor = event.target.value;
        setColor(newColor); // Update the local color state
        setFormData((prevFormData) => ({
            ...prevFormData,
            color: newColor, // Update formData with the new color
        }));
    };


    const handleGenerateAppraisalCertificate = async () => {
        console.log('Generating PDF with selectedImages:', selectedImages);

        const currentDate = new Date().toLocaleDateString('en-US');

        // Ensure `notes` is an array:
        const sanitizedNotes = Array.isArray(notes)
            ? notes
            : typeof notes === 'string'
                ? notes.split('\n')
                : [];

        setIsLoading(true);

        try {
            const pdfBlob = await pdf(
                <AppraisalCertificate
                    formData={formData}
                    notes={sanitizedNotes}
                    selectedImages={selectedImages}
                    currentDate={currentDate}
                />
            ).toBlob();

            console.log('Data passed to PDF:', formData);

            // Construct the filename from the two exact fields in `formData`:
            const vinValue = formData['VIN Number'] || 'UNKNOWN_VIN';
            const ymmValue = formData['Year Make Model'] || 'UNKNOWN_YMM';
            const fileName = `${vinValue} - ${ymmValue}.pdf`;

            // Trigger the download:
            const url = URL.createObjectURL(pdfBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error generating the PDF:', error);
        } finally {
            setIsLoading(false);
        }
    };






    const handleImageSelect = async (file) => {
        try {
            console.log('File object passed to handleImageSelect:', file);

            const proxiedUrl = `${API_BASE_URL}/proxy-file?fileUrl=${encodeURIComponent(file.FileUrl)}`;
            console.log('Proxied URL:', proxiedUrl);

            const base64Image = await fetchBase64Image(proxiedUrl);
            console.log('Base64 image:', base64Image);

            setSelectedImages((prevImages) => {
                if (prevImages.length >= 6) {
                    alert('You can only select up to 6 images.');
                    return prevImages;
                }
                return [...prevImages, base64Image];
            });
        } catch (error) {
            console.error('Error selecting image:', error);
        }
    };





    const handlePreview = (fileUrl) => {
        if (!fileUrl) {
            console.error('Invalid file URL');
            return;
        }
        window.open(fileUrl, '_blank');
    };



    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value, // Update the specific field in formData
        }));
    };



    const assignHandler = () => {
        setOnClickHandler(() => {
            console.log("Button clicked!");
        });
    };





    const saveCertificateData = async (event) => {
        event.preventDefault();

        setIsLoading(true);

        try {
            console.log('Saving certificate data with updated PDF');

            // Ensure notes is always an array
            const sanitizedNotes = Array.isArray(notes)
                ? notes
                : typeof notes === 'string'
                    ? notes.split('\n')
                    : [];

            // Generate the PDF blob
            const pdfBlob = await pdf(
                <AppraisalCertificate
                    formData={formData} // Ensure this contains the latest data
                    notes={sanitizedNotes} // Pass sanitized notes here
                    selectedImages={selectedImages} // Include selectedImages
                    currentDate={new Date().toLocaleDateString('en-US')}
                />
            ).toBlob();

            // Prepare FormData for the request
            const formDataToUpload = new FormData();
            formDataToUpload.append('pdfFile', pdfBlob, 'AppraisalCertificate.pdf'); // Attach the new PDF
            formDataToUpload.append('formData', JSON.stringify({
                ...formData, // Include all certificate data
                notes: sanitizedNotes, // Updated notes
                images: selectedImages, // Add the selected images to the form data
            }));

            // Send the update request to the backend
            const response = await fetch(`${API_BASE_URL}/api/updateCertificate/${id}`, {
                method: 'PUT',
                body: formDataToUpload, // Automatically sets multipart/form-data
            });

            if (response.ok) {
                const { updatedCertificate } = await response.json();
                console.log('Certificate updated successfully with new PDF URL:', updatedCertificate);
                setFormData(updatedCertificate); // Update the state with the response
                alert(`Certificate updated successfully`);
            } else {
                const errorMessage = await response.text();
                console.error('Failed to update certificate:', errorMessage);
                alert(`Failed to update certificate: ${errorMessage}`);
            }
        } catch (error) {
            console.error('Error during save and upload:', error);
            alert('An error occurred while saving the certificate. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };












    const openModal = async () => {
        await generatePdfPreview(); // Generate PDF before opening modal
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        if (pdfBlobUrl) URL.revokeObjectURL(pdfBlobUrl); // Free up memory
    };

    const getCurrentDate = () => {
        return new Date().toLocaleDateString(); // or toLocaleString(), or any format you prefer
    };

    const generatePdfPreview = async () => {
        const currentDate = getCurrentDate();

        // 1) Force `notes` to be an array:
        const forcedNotes = Array.isArray(notes)
            ? notes                        // if already an array, use it
            : notes
                ? notes.split('\n')            // if it's a string, split on new lines
                : [];                          // if it's null/undefined, just use empty array

        console.log('Generating PDF with forcedNotes:', forcedNotes);
        console.log('Date for PDF preview:', currentDate);

        try {
            const pdfBlob = await pdf(
                <AppraisalCertificate
                    formData={formData}
                    notes={forcedNotes}       // pass the forced array
                    selectedImage={selectedImage}
                    currentDate={currentDate}
                />
            ).toBlob();
            const url = URL.createObjectURL(pdfBlob);
            setPdfBlobUrl(url);
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };









    const fetchFiles = async () => {
        try {
            // Ensure contactId is valid before making the API call
            if (!contactId) {
                console.error('Contact ID is missing');
                return;
            }

            console.log('Fetching files for contactId:', contactId);

            // Make the API call
            const response = await fetch(`${API_BASE_URL}/api/crm/get-files?contactId=${contactId}`);

            console.log('API Request URL:', `${API_BASE_URL}/api/crm/get-files?contactId=${contactId}`);

            if (!response.ok) {
                const error = await response.json();
                console.error('Error response from API:', error);
                throw new Error(error.error || 'Failed to fetch files');
            }

            // Parse and handle the response
            const data = await response.json();
            console.log('Fetched Files:', data);

            // Filter valid files
            const imageFiles = Array.isArray(data.files)
                ? data.files.filter((file) => file.FileUrl && ['png', 'jpg', 'jpeg'].includes(file.FileType?.toLowerCase()))
                : [];

            if (imageFiles.length === 0) {
                console.log('No valid images found for contactId:', contactId);
                setError('No CRM images related to this contact');
            } else {
                console.log('Valid images fetched:', imageFiles);
                setError(''); // Clear previous errors
                setFiles(imageFiles);
            }
        } catch (error) {
            console.error('Error fetching files:', error.message);
            setError('Failed to fetch files');
        }
    };






    const fetchBase64Image = async (url) => {
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Failed to fetch image. Status: ${response.status}`);
            }
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result); // Returns base64 string
                reader.onerror = (error) => reject(error);
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('Error in fetchBase64Image:', error);
            throw error;
        }
    };


    useEffect(() => {
        const fetchCertificate = async () => {
          try {
            setLoading(true);
      
            const response = await fetch(`${API_BASE_URL}/api/getCertificate/${id}`);
            if (!response.ok) throw new Error('Failed to fetch certificate');
      
            const data = await response.json();
            console.log('Fetched certificate data:', data);
      
            // Merge fetched data into existing formData
            setFormData((prevData) => ({
              ...prevData,
              ...data,
            }));
      
            setContactId((prevContactId) => data.ContactId || data.contactId || prevContactId || '');
      
            // >>> Convert data.notes to array if it's a string
            setNotes((prevNotes) => {
              if (typeof data.notes === 'string') {
                // Convert multiline string into array of lines
                return data.notes.split('\n');
              } else if (Array.isArray(data.notes)) {
                // Already an array
                return data.notes;
              } else {
                // If no notes returned, keep what we had or empty array
                return prevNotes || [];
              }
            });
      
            // Update images
            setSelectedImages(Array.isArray(data.images) ? data.images : []);
          } catch (error) {
            console.error('Error fetching certificate:', error);
          } finally {
            setLoading(false);
          }
        };
      
        fetchCertificate();
      }, [id]);
      




    useEffect(() => {
        if (contactId) {
            console.log('Fetching files for contactId:', contactId);

            const fetchFiles = async () => {
                try {
                    const response = await fetch(`${API_BASE_URL}/api/crm/get-files?contactId=${contactId}`);
                    if (!response.ok) throw new Error('Failed to fetch files');

                    const data = await response.json();
                    console.log('Fetched files:', data);

                    const imageFiles = Array.isArray(data.files)
                        ? data.files.filter((file) => file.FileUrl && ['png', 'jpg', 'jpeg'].includes(file.FileType?.toLowerCase()))
                        : [];

                    setFiles(imageFiles);
                } catch (error) {
                    console.error('Error fetching files:', error);
                }
            };

            fetchFiles();
        } else {
            console.error('Contact ID is missing; files cannot be fetched.');
        }
    }, [contactId]);

    useEffect(() => {
        // Pre-select image from formData if available
        if (formData?.certificateImageName && files.length > 0) {
            console.log('Pre-selecting image by name:', formData.certificateImageName);

            const matchedFile = files.find((file) => file.FileName === formData.certificateImageName);
            if (matchedFile) {
                setSelectedImage({
                    name: matchedFile.FileName,
                    url: matchedFile.FileUrl,
                });
            }
        }
    }, [formData, files]);



    return (
        <div
            style={{
                background: 'linear-gradient(237deg, rgba(39, 39, 39, 0) 70%, rgba(0, 195, 116, 0.4) 120%), #272727',
                backgroundAttachment: 'fixed', // This fixes the background in place
                backgroundSize: 'cover', // Ensure the background covers the whole page
                minHeight: '100vh', // Ensure the container takes at least the full viewport height
                color: '#fff', // Ensure text color contrasts with background
                display: 'flex',
                flexDirection: 'column', // Stack elements vertically
                justifyContent: 'center', // Center content vertically
                alignItems: 'center', // Center content horizontally
                textAlign: 'center', // Align text in the center

            }}
        >
            <header>
                <Link to="/">
                    <div className="logo">
                        <img src="/ae.svg" alt="Logo" className='header-image' />
                    </div>
                </Link>

                <div className="actions">

                    <button className="export" onClick={handleGenerateAppraisalCertificate} disabled={isLoading}>
                        <img className="download-icon" src="/image 4.png" alt="Export" />
                        {isLoading ? 'Export' : 'Export'}
                    </button>
                    <button className="clear" onClick={onClickHandler}>Clear</button>


                    <button
                        className="google-button"
                        onClick={saveCertificateData} // Call the save function
                        onMouseEnter={() => setSaveButtonImageSrc('/saveFormHover.svg')}
                        onMouseLeave={() => setSaveButtonImageSrc('/saveButtonHeader.svg')}
                    >
                        <img src={saveButtonImageSrc} alt="Save" />
                    </button>



                    <button
                        className="otherButtons"
                        onClick={openModal}
                        // Change image on mouse enter and leave
                        onMouseEnter={() => setPreviewImageSrc('/previewButtonHover.svg')} // Change to the new image on hover
                        onMouseLeave={() => setPreviewImageSrc('/previewButtonHeader.svg')} // Change back to the original image
                    >
                        <img src={previewImageSrc} alt="Preview" />
                    </button>


                    <button
                        className="otherButtons"
                        onClick={() => {
                            window.scrollTo(0, 0); // Scroll to the top of the page
                            navigate('/SearchCertificate'); // Redirect to /forms
                        }}
                        onMouseEnter={() => setSavedFormsImageSrc('/savedFormsHover.svg')}
                        onMouseLeave={() => setSavedFormsImageSrc('/savedFormsButtomHeader.svg')}
                    >
                        <img src={savedFormsImageSrc} alt="Saved Forms" />
                    </button>
                </div>
            </header>


            <div className="containerRequest">
                <div className='titleDiv'>
                    <h1 className='bigTitle'>Appraisal Report</h1>
                    <p className='subTitle'>Review the data and generate your certificate of appraisal.</p>
                </div>

                <div className="form-section display-section">
                    <div className="contactInfo">
                        <label className="form-label" htmlFor="contactId">Contact being edited details:</label>
                        <div className="contact-details">
                            <span className="contact-id">ID: {contactId}</span>
                        </div>
                        <div className="contact-details">
                            <span className="contact-id">Name: {formData?.Name?.FirstName || 'First Name'} {formData?.Name?.LastName || 'Last Name'}</span>
                        </div>
                    </div>
                </div>

                <section className="form-section">
                    <h2 className='titlesCertificate'>Claim Information</h2>
                    <form>
                        <div className="form-group">
                            <label className="titleForInformation" htmlFor="vehicleOwner">Yeak / Make / Model</label>
                            <input
                                className='vehicleOwner'
                                type="text"
                                id='yearmakemodel'
                                value={formData?.['Year Make Model'] || ''} // Default to empty string if undefined
                                onChange={(e) =>
                                    setFormData({ ...formData, ['Year Make Model']: e.target.value }) // Update state on input change
                                }
                            />
                        </div>

                        <div className="form-group">
                            <label className="titleForInformation" htmlFor="fileNumber">VIN</label>
                            <input
                                className="fileNumber"
                                type="text"
                                id="vin"
                                maxLength={17} // Limit the input to 17 characters
                                value={formData?.['VIN Number'] || ''} // Default to empty string if undefined
                                onChange={(e) =>
                                    setFormData({ ...formData, ['VIN Number']: e.target.value }) // Update state on input change
                                }
                            />
                        </div>

                        {/*HERE THE DIVS GOTTA APPEAR half  */}

                        <div className="halfInputContainers">
                            <div className="twoInputs">
                                <div className="form-group">
                                    <label className="titleForInformation" htmlFor="valuationDate">Valuation Date</label>
                                    <input
                                        className="halfInput"
                                        type="date"
                                        id="valuationdate"
                                        value={formData?.['valuationDate'] || ''} // Default to empty string if undefined
                                        onChange={(e) => {
                                            const updatedDate = e.target.value;
                                            console.log('Updated Valuation Date:', updatedDate); // Log updated value
                                            setFormData({ ...formData, ['valuationDate']: updatedDate }); // Update state
                                        }}
                                    />
                                </div>
                                <div className="form-group" style={{ left: '-39px' }}>
                                    <label className="titleForInformation" htmlFor="actualCashValue">Actual Cash Value</label>
                                    <input
                                        className="halfInput"
                                        type="text"
                                        name="Actual Cash Value"
                                        value={
                                            formData?.['Actual Cash Value']
                                                ? `$${formData['Actual Cash Value'].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}` // Add $ and format with commas
                                                : ''
                                        }
                                        onChange={(e) => {
                                            const rawValue = e.target.value.replace(/[^0-9.]/g, ''); // Strip non-numeric characters
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                'Actual Cash Value': rawValue, // Save the raw numeric value without formatting
                                            }));
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="twoInputs">
                                <div className="form-group">
                                    <label className="titleForInformation" htmlFor="odometerReading">Odometer Reading</label>
                                    <input
                                        className="halfInput"
                                        type="text"
                                        id="odometer"
                                        value={formData?.['Miles'] || ''} // Default to empty string if undefined
                                        onChange={(e) =>
                                            setFormData({ ...formData, ['Miles']: e.target.value }) // Update state on input change
                                        }
                                    />
                                </div>
                                <div className="form-group" style={{ left: '-39px' }} /* Adjust negative margin to move left */>
                                    <label className="titleForInformation" htmlFor="color">Color</label>
                                    <input
                                        className="halfInput"
                                        type="text"
                                        name="Vehicle Color" // Match the key in formData
                                        placeholder="Insert Color"
                                        value={formData?.['Vehicle Color'] || ''} // Controlled component
                                        onChange={(e) =>
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                'Vehicle Color': e.target.value, // Update the correct key in formData
                                            }))
                                        }
                                    />
                                </div>
                            </div>

                            <div className="twoInputs">
                                <div className="form-group">
                                    <div className="conditionAndGradeLabelsContainer">
                                        <label className="titleForCondition" htmlFor="preLossCondition">Pre-Loss Condition</label>
                                        <label className="gradeLabel" htmlFor="preLossGrade">Grade</label>
                                    </div>
                                    <div className="preLossGradeContainer">
                                    <select
                                            className="halfInputCondition"
                                            value={formData?.['Pre-Loss Condition'] || ''} // Safely access the selected condition
                                            onChange={(e) =>
                                                setFormData((prevFormData) => ({
                                                    ...prevFormData,
                                                    'Pre-Loss Condition': e.target.value, // Update the correct key in formData
                                                }))
                                            }
                                        >
                                            <option value="" disabled>
                                                Select Condition
                                            </option>
                                            <option value="Brand New">Brand New</option>
                                            <option value="Showroom">Showroom</option>
                                            <option value="Restored Original">Restored Original</option>
                                            <option value="Restomod">Restomod</option>
                                            <option value="Excellent">Excellent</option>
                                            <option value="Good">Good</option>
                                            <option value="Fair">Fair</option>
                                            <option value="Poor">Poor</option>
                                            <option value="Inoperable">Inoperable</option>
                                            <option value="Parts Car">Parts Car</option>
                                            <option value="Junk">Junk</option>
                                        </select>
                                        <input
                                            className="halfInputGrade"
                                            type="number"
                                            value={formData?.['Grade'] || ''} // Safely access grade
                                            onChange={(e) =>
                                                setFormData({ ...formData, 'Grade': e.target.value }) // Update the correct key in formData
                                            }
                                            placeholder="Grade"
                                        />
                                    </div>
                                </div>
                                <div className="form-group" style={{ left: '-39px' }}>
                                    <label className="titleForInformation" htmlFor="marketArea">Market Area</label>
                                    <input
                                        className="halfInput"
                                        type="text"
                                        name="Market Area"
                                        value={formData?.['Market Area'] || ''}
                                        onChange={(e) => setFormData((prev) => ({
                                            ...prev,
                                            'Market Area': e.target.value, // Update dynamically
                                        }))}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <label className="titleForInformation" htmlFor="appraiserNotes">Appraiser Notes</label>
                            <textarea
                                className="appraisalNotes"
                                value={Array.isArray(notes) ? notes.join('\n') : ''}
                                onChange={(e) => {
                                    setNotes(e.target.value.split('\n'));
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <h2 className="titlesCertificate">Vehicle Picture</h2>
                            <section className="form-section">
                                <form>
                                    <div className={`file-upload`}>
                                        <input
                                            type="file"
                                            id="uploadBlackBook"
                                            name="uploadBlackBook"
                                            accept="image/*"
                                            onChange={handleFileChange} // Handle new file selection
                                            multiple
                                        />
                                        <label htmlFor="uploadBlackBook" className="file-upload-button">
                                            Select Files
                                        </label>
                                    </div>
                                </form>
                                <div className="selected-image-container-wrapper">
                                    <div className="selected-image-container">
                                        {selectedImages.length > 0 ? (
                                            <div className="selected-images-row">
                                                {selectedImages.map((image, index) => (
                                                    <div key={index} className="selected-image-item">
                                                        <img
                                                            src={image}
                                                            alt={`Selected ${index + 1}`}
                                                            className="selected-image-preview"
                                                        />
                                                        <button
                                                            type="button"
                                                            className="remove-image-button"
                                                            onClick={() =>
                                                                setSelectedImages((prevImages) =>
                                                                    prevImages.filter((_, i) => i !== index)
                                                                )
                                                            }
                                                        >
                                                            X
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p>No images selected for PDF</p>
                                        )}
                                    </div>
                                </div>
                            </section>
                            <div className="imgsDiv">
                                {files.length > 0 ? (
                                    files.map((file) => (
                                        <div key={file.FileId} className="rowImg">
                                            <p className="imgName" onClick={() => handleImageSelect(file)}>
                                                {file.FileName}
                                            </p>
                                            <button
                                                className="addToPdfButton"
                                                type="button"
                                                onClick={() => {
                                                    console.log('Add to PDF button clicked for file:', file);
                                                    handleImageSelect(file);
                                                }}
                                            >
                                                Add to PDF
                                            </button>
                                        </div>
                                    ))
                                ) : (
                                    <div className="no-images-message">
                                        <p>{error || 'No images to show'}</p>
                                    </div>
                                )}
                            </div>
                        </div>

                    </form>
                </section>
            </div>
            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="PDF Preview"
                className="custom-modal"
                overlayClassName="custom-overlay"
            >
                <h2>PDF Preview</h2>
                {pdfBlobUrl ? (
                    <iframe
                        src={pdfBlobUrl}
                        title="PDF Preview"
                        className="pdf-preview"
                    ></iframe>
                ) : (
                    <p>Loading preview...</p>
                )}
                <button className="close-button" onClick={closeModal}>
                    Close
                </button>
            </Modal>
        </div>
    );
};

export default EditAppraisalRequest;